import { Grid, Typography } from '@mui/material';
import { useContext } from 'react';
import { orderContext } from '../OrderContext';
import { DetailsPageHeader } from 'components';


let Due = () => {
    let service = useContext(orderContext);

    return (
        <DetailsPageHeader sectionName='DUE details'>
            <Grid container>
                <Grid item xs={3}>
                    <Typography>Payment terms</Typography>
                </Grid>
                <Grid item xs={9}>
                    <Typography>{service.order.due.paymentTerms}</Typography>
                </Grid>
                <Grid item xs={3}>
                    <Typography>Payment type</Typography>
                </Grid>
                <Grid item xs={9}>
                    <Typography>{service.order.due.paymentType}</Typography>
                </Grid>
            </Grid>
        </DetailsPageHeader>
    );
}

export default Due;